import { INTEGRATED_APP_HOME_PAGE_URL_PREFIX } from "utils/integration/constants";
import { useLocation } from "react-router-dom";

export const useIsIntegratedAppHomePage = () => {
  const location = useLocation();
  return location.pathname.split("/").includes(INTEGRATED_APP_HOME_PAGE_URL_PREFIX);
};